import { BaseContainerModel } from '../../base-container.model';
import {
  bl_fi_mst_pricing_scheme_list_exts_RowClass,
  bl_fi_mst_pricing_scheme_list_hdr_RowClass
} from '../../../dbschema';

export class PricingSchemeListContainerModel extends BaseContainerModel {
  bl_fi_mst_pricing_scheme_list_exts: bl_fi_mst_pricing_scheme_list_exts_RowClass = new bl_fi_mst_pricing_scheme_list_exts_RowClass();
  bl_fi_mst_pricing_scheme_list_hdr: bl_fi_mst_pricing_scheme_list_hdr_RowClass;
}